<template>
  <div style="display:flex;height:100%">
    <div style="background-color:#eee;width:217px;height: 99.5%;border-bottom: 1px solid #999;">
      <footer></footer>
      <!-- 好友列表 -->
      <ul>
        <li>
          <img class="avatars" width="30" height="30" :src="require('@/assets/images/bindmessage.png')">
          <p class="name">绑定账号</p>
        </li>
      </ul>
    </div>
    <div style="flex:1;background-color:#fefefe">
      <div style="border-bottom: 1px solid rgb(204, 204, 204);display: flex;justify-content: space-between;">
        <div class="message-head" style="padding: 21.5px 21px;box-sizing: border-box;flex: 3;">
          <span v-if="isFriend && !isemptyShow">{{userList.length>0 ? !isFriend ? ' ' : userList.filter(item => item.id === session.userId)[0].name : ' '}}</span>
          <span v-else>&nbsp;</span>
        </div>
        <span style="cursor:pointer;flex: 1;display: flex;justify-content: space-around;align-items: center;">
          <img style="cursor: pointer;" :src="require('@/assets/images/mini.png')" alt="最小化" @click="$emit('close')">
          <img style="cursor: pointer;" :src="require('@/assets/images/react.png')"  @click="$emit('toggleFullScreen')">
          <img style="cursor: pointer;" :src="require('@/assets/images/close.png')" alt="关闭" @click="$emit('close')">
        </span>
      </div>
      <!-- 绑定账号 -->
      <div style="box-sizing:border-box;padding:20px 40px;height:calc(100% - 222px);">
        <div style="margin-bottom:50px;">
          <el-form size="mini" label-width="120px">
            <el-form-item label="绑定类型">
              <el-select v-model="form.type" @change="handleselect">
                <el-option label="总部" value="1"></el-option>
                <el-option label="子公司" value="2"></el-option>
                <el-option label="C端" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="form.type">
          <el-form size="small" label-width="120px" :rules="rules" ref="form" :model="form">
            <el-form-item label="账号" prop="userName">
              <el-input v-model="form.userName">
                <el-button v-if="form.type == 3" slot="append" icon="el-icon-search" @click="searchProjectCode"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="公司编码" v-if="form.type == 2" prop="branchCode">
              <el-input v-model="form.branchCode"></el-input>
            </el-form-item>
          </el-form>
          <!-- projectCode信息 -->
          <div v-if="codeList.length>0 && form.type == 3" style="height: 130px;overflow: auto;display:flex;flex-wrap:wrap;margin-bottom: 10px;">
            <div 
              v-for="(item,i) in codeList" 
              :key="i" 
              :style="{
                'display': 'flex',
                'flex-direction': 'column',
                'align-items': 'center',
                'margin-right': '10px',
                'margin-bottom': '10px',
                'width': '60px',
                'height':'75px',
                'box-sizing': 'border-box',
                'padding': '5px 0px',
                'border':chooseindex == i ? '2px solid green' : '2px solid #ccc'}" 
              @click="chooseCode(item,i)">
              <img :src="item.headportrait" alt="" style="width: 40px;height: 40px;">
              <span>{{item.projectCode}}</span>
            </div>
          </div>
          <div style="text-align:right">
            <el-button size="small" style="width:82%" type="primary" @click="confirm" :loading="loading">确认绑定</el-button>
          </div>
        </div>
      </div>
      <!-- 展示已经绑定的账号 -->
      <div style="border-top:1px solid #ccc;height:158px;box-sizing:border-box;padding:10px;overflow:auto;border-bottom: 1px solid #999;">
        <div v-for="(item,i) in bindList" :key="i" style="margin-bottom: 15px;">
          <span style="color:#999">{{item.parentName}}</span>
          <div style="display:flex;box-sizing: border-box;padding: 10px;flex-wrap: wrap;">
            <div v-for="(_it,j) in item.children" :key="j" style="display:flex;align-items: center;width: 35%;margin-bottom:10px">
              <img width="40" height="40" :src="_it.headportrait" alt="">
              <span style="margin-left:10px">{{_it.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['session','isFriend','isemptyShow','userList'],
  data() {
    return {
      loading:false,
      form:{
        type:'',
        userName:'',
        password:'',
        branchCode:'',
        chatId:sessionStorage.getItem('chatid'),
        projectCode:''
      },
      chooseindex:null,
      bindList:[],
      codeList:[],
      rules:{
        userName: [
          { required: true, message: '请输入绑定账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入绑定密码', trigger: 'blur' }
        ],
        branchCode: [
          { required: true, message: '请输入公司编号', trigger: 'blur' }
        ],
      },
    };
  },
  mounted(){
    this.getBind()
  },
  methods: {
    /*
     *@Author: 张俊娜
     *@Date: 2021-05-20 10:51:55
     *@Description: 绑定类型切换的时候清空掉数据
    */
    handleselect(){
      this.form.userName = ''
      this.form.password = ''
      this.form.branchCode = ''
      this.form.projectCode = ''
      this.chooseindex = null
    },
    /*
     *@Author: 张俊娜
     *@Date: 2021-05-20 10:21:13
     *@Description: 选中projectcode事件
    */
    chooseCode(item,i){
      this.chooseindex = i
      this.form.projectCode = item.projectCode
    },
    // 确认绑定
    confirm(){
      // C端绑定确认是否全部填写
      if(this.form.type == 3 && !this.form.projectCode){
        this.$message.info('请选择绑定的C端用户')
        return 
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.axios({
            url: this.zuul + "/xyj-im/w/imUsertable/bindUser",
            method: "post",
            data: this.form,
          })
          .then((res) => {
            this.$message({
              type: "warning",
              message: res.msg,
            });
            this.form.type=''
            this.form.userName=''
            this.form.password=''
            this.form.branchCode=''
            this.getBind()
            this.loading = false
          })
          .catch((err) => {
            this.$message.error(err.message);
            this.loading = false
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取已绑定的信息
    getBind(){
      this.axios({
        url: this.zuul + "/xyj-im/w/imUsertable/bindLog",
        method: "get",
        params: {
          chatId:sessionStorage.getItem('chatid')
        },
      })
      .then((res) => {
        let arr = [
          {parentName:'总部',type:1,children:[]},
          {parentName:'子公司',type:2,children:[]},
          {parentName:'C端',type:3,children:[]},
        ]
        res.data.forEach(item => {
          if(item.type == 1){
            arr[0].children.push(item)
          }else if(item.type == 2){
            arr[1].children.push(item)
          }else if(item.type == 3){
            arr[2].children.push(item)
          }
        })
        this.bindList = arr
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    },
    /*
     *@Author: 张俊娜
     *@Date: 2021-05-20 09:58:44
     *@Description: 查找C端projectCode信息
    */
    searchProjectCode(){
      this.axios({
        url:this.zuul+'/xyj-im/w/imUsertable/getProjectCodeByNP',
        method:'post',
        data:{
          userName:this.form.userName,
          password:this.form.password
        }
      }).then(res => {
        this.codeList = res.data
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
};
</script>

<style lang="scss" scoped>
	ul{
		margin: 0;
		padding: 0;
	}
	li {
		display: flex;
		align-items: center;
	  padding: 12px 15px;
	  cursor: pointer;
	  transition: background-color .1s;
	  list-style: none;
	}
	li:hover{
		background-color: #DDDBDA;
	}
	footer {
		padding: 30.5px 12px;
		border-bottom: 1px solid #ccc;
	}
  .name {
	  display: inline-block;
	  margin: 0 0 0 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/setting.vue